import { MeterPlacement } from '@enmon/commons/lib/enmon';
import { defineMessages } from '@/components/formatted_message/FormattedMessage';

export const METER_PLACEMENT_TRANSLATED = defineMessages<MeterPlacement>({
  [MeterPlacement.In]: { id: 'app.common.meter.placement.In' },
  [MeterPlacement.Main]: { id: 'app.common.meter.placement.Main' },
  [MeterPlacement.Out]: { id: 'app.common.meter.placement.Out' },
  [MeterPlacement.Secondary]: { id: 'app.common.meter.placement.Secondary' },
});
